/**
 * Simple localStorage cache for offline data resilience.
 * Each key is namespaced per user to avoid data leaks.
 */

const CACHE_PREFIX = "spotrai_cache_";

function cacheKey(userId: string, key: string): string {
  return `${CACHE_PREFIX}${userId}_${key}`;
}

export function setCachedData<T>(userId: string, key: string, data: T): void {
  try {
    localStorage.setItem(
      cacheKey(userId, key),
      JSON.stringify({ data, ts: Date.now() })
    );
  } catch {
    // Storage full or unavailable — silently ignore
  }
}

export function getCachedData<T>(userId: string, key: string): T | null {
  try {
    const raw = localStorage.getItem(cacheKey(userId, key));
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed.data as T;
  } catch {
    return null;
  }
}

export function clearUserCache(userId: string): void {
  try {
    const keysToRemove: string[] = [];
    for (let i = 0; i < localStorage.length; i++) {
      const k = localStorage.key(i);
      if (k?.startsWith(`${CACHE_PREFIX}${userId}_`)) {
        keysToRemove.push(k);
      }
    }
    keysToRemove.forEach((k) => localStorage.removeItem(k));
  } catch {
    // Ignore
  }
}
